import * as Label from '@radix-ui/react-label';
import { type ReactNode } from 'react';
import { cn } from '@/lib/cn';

interface FieldProps {
  id: string;
  label: string;
  error?: string;
  hint?: string;
  children: ReactNode;
  className?: string;
}

export function Field({ id, label, error, hint, children, className }: FieldProps) {
  return (
    <div className={cn('flex flex-col gap-2', className)}>
      <Label.Root
        htmlFor={id}
        className="text-label uppercase tracking-[0.08em] text-text-secondary"
      >
        {label}
      </Label.Root>
      {children}
      {error ? (
        <p className="text-body-sm text-danger" role="alert">
          {error}
        </p>
      ) : hint ? (
        <p className="text-body-sm text-text-secondary">{hint}</p>
      ) : null}
    </div>
  );
}
